/**
 * 下端追従 CTA（閾値でフェードイン、フッター直上に密着させるよう bottom を調整）
 * フッターは `[data-js-site-footer]` を付与した要素を参照（`parts/temp/temp-footer.php` 等）
 */
export default class StickyCtaBar {
  init() {
    const bar = document.querySelector('[data-js-sticky-cta-bar]');
    const footer = document.querySelector('[data-js-site-footer]');
    if (!bar) {
      return;
    }

    const revealPx = Number.parseInt(bar.getAttribute('data-sticky-cta-reveal'), 10) || 220;
    let ticking = false;

    const update = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      const revealed = scrollY >= revealPx;

      bar.classList.toggle('is-visible', revealed);
      document.body.classList.toggle('has-sticky-cta-visible', revealed);

      if (revealed) {
        document.body.style.setProperty('--sticky-cta-bar-h', `${bar.offsetHeight}px`);
        bar.removeAttribute('inert');
        bar.removeAttribute('aria-hidden');
      } else {
        document.body.style.removeProperty('--sticky-cta-bar-h');
        bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', 'true');
      }

      let liftPx = 0;
      if (footer && footer.offsetHeight > 0) {
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const footerTop = footer.getBoundingClientRect().top;
        // ビューポート下端〜フッター上端までのオフセット＝fixed の bottom。フッター先頭にぴったり接する
        liftPx = Math.max(0, vh - footerTop);
      }

      liftPx = Math.round(liftPx);

      bar.style.setProperty('--sticky-cta-lift', `${liftPx}px`);

      ticking = false;
    };

    const onTick = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    };

    window.addEventListener('scroll', onTick, { passive: true });
    window.addEventListener('resize', onTick);

    update();
  }
}
